module.exports = __webpack_public_path__ + "img/PagodeDerechos.ad98540b.png";